import {createVuetify} from "vuetify"
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import {aliases, mdi} from 'vuetify/iconsets/mdi'

import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'

export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.vueApp.use(
        createVuetify({
            components,
            directives,
            theme: {
                defaultTheme: 'light',
                themes: {
                    light: {
                        dark: false,
                        colors: {
                            primary: '#3643BA',
                            'dark-primary': '#2E399E',
                            gray: '#a0a0a0',
                            'quiet-gray': '#616161',
                            'dark-gray': '#4E5D6BCC',
                            'light-gray': '#F5F5F5',
                            'primary-light': '#D9ECF5',
                            'light-blue': '#9ADDFF',
                            completed: '#149B65',
                            'not-completed': '#DB6900',
                            in_progress: '#0113B6FF',
                            to_be_processed: '#EC6607',
                            archive: '#D70321',
                            yes: '#149B65',
                            no: '#ff0000',
                            'not-concerned': '#3643BA'
                        }
                    }
                }
            },
            icons: {
                defaultSet: 'mdi',
                aliases,
                sets: {mdi}
            }
        })
    )
})